// "START HERE" highlight of the tool card picked in the first-visit onboarding modal
// (ListTools reads ?startHere=onpage|aiwriter|keyword|aivis once and passes it down).
export const startHereMixin = {
  props: {
    startHere: { type: Boolean, default: false },
  },
  watch: {
    startHere: {
      immediate: true,
      handler (value) {
        if (!value) return
        this.$nextTick(() => {
          try {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          } catch (e) {
            // older browsers: the highlight alone is enough
          }
        })
      },
    },
  },
}
